import { useState, useEffect } from "react";
import { getCurrentEnvironmentName } from "Selectors/app";
import { useSelector } from "react-redux";
import { useCollectionSchema } from "../../../Api/services/schemaAnalyzer";

export const useAnalyzeSchema = () => {
	const [selectedCollection, setSelectedCollection] = useState("");
	const [hasLimit, setHasLimit] = useState(true);
	const [sampleSize, setSampleSize] = useState(100);
	const [noCache, setNoCache] = useState(false);

	const environment = useSelector(getCurrentEnvironmentName);
	const {
		data: collectionSchemaData,
		refetch: fetchCollectionSchema,
		schema,
		progress,
		asOf,
		cached,
	} = useCollectionSchema(environment, selectedCollection, hasLimit ? sampleSize : null, noCache);

	useEffect(() => {
		if (selectedCollection) {
			if (hasLimit) {
				fetchCollectionSchema(sampleSize);
			} else {
				fetchCollectionSchema();
			}
		}
	}, [selectedCollection, fetchCollectionSchema, hasLimit, sampleSize]);

	const handleAnalyzeCollection = async (collectionName) => {
		setSelectedCollection(collectionName);
	};

	const onAnalyze = () => {
		if (hasLimit) {
			fetchCollectionSchema(sampleSize);
		} else {
			fetchCollectionSchema();
		}
	};

	return {
		asOf,
		isFromCache: cached,
		collectionSchemaData: collectionSchemaData,
		hasLimit,
		selectedCollection,
		schema,
		sampleSize,
		progress,
		noCache,
		setNoCache,
		handleAnalyzeCollection,
		setHasLimit,
		setSampleSize,
		onAnalyze,
	};
};
